module.exports = __webpack_public_path__ + "media/addToHomescreen.7c41bea0.mp4";